module.exports = __webpack_public_path__ + "officialStatic/img/mapBg.8fdf049.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/mapBg.png
// module id = +CoB
// module chunks = 0